var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[_c('main-company-name'),_c('main-options'),_c('main-introduce'),_c('main-tip-msg'),_c('certificationPage'),_c('otherBusiness'),_c('main-about-msg')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }